import React from "react";

const Projects = () => {
  return (
    <section id="projects">
      <h2>Projects</h2>

      {/* Portfolio Website */}
      <details className="project-container">
        <summary className="project-title">Portfolio Website</summary>
        <img
          src={`${process.env.PUBLIC_URL}/images/portfolio-preview.png`}
          alt="Portfolio website preview"
          className="project-image"
        />
        <p className="project-description">
          My personal portfolio built with <strong>React 18</strong> and{" "}
          <strong>Redux Toolkit</strong>. Features dark mode, smooth animations,
          and a fully responsive layout. Deployed on <strong>Netlify</strong> and
          connected to GitHub for continuous updates.
        </p>
      </details>

      {/* MyJamming */}
      <details className="project-container">
        <summary className="project-title">MyJamming (Demo)</summary>
        <img
          src={`${process.env.PUBLIC_URL}/images/myjamming.png`}
          alt="Deezer clone project preview"
          className="project-image"
        />
        <p className="project-description">
          A music discovery app inspired by Spotify and Deezer. Built with{" "}
          <strong>React</strong> and the <strong>Deezer API</strong> for
          real-time search and playlist creation. Focused on API integration and
          clean UI design.
        </p>
      </details>

      {/* MyReddit */}
      <details className="project-container">
        <summary className="project-title">MyReddit (Demo)</summary>
        <img
          src={`${process.env.PUBLIC_URL}/images/myreddit.png`}
          alt="Reddit clone project preview"
          className="project-image"
        />
        <p className="project-description">
          A <strong>Reddit-style app</strong> built with <strong>React</strong>{" "}
          and <strong>Redux Toolkit</strong>, using the Reddit JSON API for data
          fetching. Includes async thunks, Markdown rendering, and proxy-based
          CORS handling. <em>Currently under development.</em>
        </p>
      </details>
      
      {/* E-commerce Project */}
      <details className="project-container">
        <summary className="project-title">E-Commerce Website (Demo)</summary>
        <img
          src={`${process.env.PUBLIC_URL}/images/ecommerce.png`}
          alt="E-commerce website preview"
          className="project-image"
        />
        <p className="project-description">
          A full-stack <strong>e-commerce app</strong> built with{" "}
          <strong>React</strong> on the front end and{" "}
          <strong>Node.js / Express</strong> with a{" "}
          <strong>PostgreSQL</strong> database on the back end. Includes
          product listing, cart management, and checkout simulation — developed
          to practice API design and backend integration.
        </p>
      </details>

      {/* Video/Data Analysis Job */}
      <details className="project-container">
        <summary className="project-title">Video/Data Analysis Job</summary>
        <img
          src={`${process.env.PUBLIC_URL}/images/analysis.png`}
          alt="Data analysis visuals"
          className="project-image"
        />
        <p className="project-description">
          A <strong>video-driven performance analysis</strong> project with <strong>HUDL Sportcode</strong> and{" "}
          <strong>data visualization</strong> to evaluate player and team
          performance. Focused on <strong>video and data storytelling</strong>,{" "}
          <strong>insight generation</strong>, and <strong>analytical workflows</strong>.
        </p>
      </details>

      {/* Public Analysis Projects */}
      <details className="project-container">
        <summary className="project-title">Public Analysis Projects</summary>
        <img
          src={`${process.env.PUBLIC_URL}/images/public-analysis.png`}
          alt="Public analysis posts preview"
          className="project-image"
        />
        <p className="project-description">
          A collection of <strong>data-driven posts and visual analyses</strong>{" "}
          published on <strong>LinkedIn</strong> and <strong>X (Twitter)</strong>.
          These explore <strong>football performance</strong>,{" "}
          <strong>analytics</strong>, and <strong>tactical insights</strong>{" "}
          through <strong>data visualization</strong> and{" "}
          <strong>storytelling</strong>.
        </p>
        <p className="project-description">
          You can view my latest work on{" "}
          <a
            href="https://www.linkedin.com/in/daniel-cserpak"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>{" "}
          or{" "}
          <a
            href="https://twitter.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            X
          </a>.
        </p>
      </details>

      {/* Codecademy Path */}
      <details className="project-container">
        <summary className="project-title">Codecademy Full-Stack Path</summary>
        <img
          src={`${process.env.PUBLIC_URL}/images/codecademy.png`}
          alt="Codecademy learning dashboard"
          className="project-image"
        />
        <p className="project-description">
          Completed the <strong>Full-Stack Engineer Path</strong> on Codecademy,
          learning <strong>React, JavaScript, Node.js, Express, and SQL</strong>{" "}
          through interactive projects. Gained practical experience in both
          front-end and back-end development.
        </p>
      </details>
    </section>
  );
};

export default Projects;
